import * as yup from 'yup'

import { requiredString, pageNum, pageSize } from '../../yup/schemas.js'

import { jobSchema } from '../general.schema.js'

const jobTemplateSchema = yup.object({
  id: requiredString.uuid(),
  name: requiredString,
  template: jobSchema.omit(['id', 'groupId', 'status', 'autoRenew', 'jobsBoardType']).allFieldsOptional()
}).objectRequired()

const createTemplateFromSchema = jobTemplateSchema.pick(['name'])

const getJobTemplateListQueryParamsSchema = yup.object({
  pageNum,
  pageSize
}).objectRequired()

const createJobTemplateSchemas = {
  front: jobTemplateSchema.omit(['id']),
  back: jobTemplateSchema.omit(['id'])
}
const createTemplateFromSchemas = { front: createTemplateFromSchema, back: createTemplateFromSchema }
const getJobTemplateListQueryParamsSchemas = { front: getJobTemplateListQueryParamsSchema, back: getJobTemplateListQueryParamsSchema }

export default {
  createJobTemplate: createJobTemplateSchemas,
  createTemplateFrom: createTemplateFromSchemas,
  getJobTemplateListQueryParams: getJobTemplateListQueryParamsSchemas
}
